<template>
    <div class="answer-detail">
        <div class="answer-detail-header">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="customBreadcrumb">
                <el-breadcrumb-item>实操训练</el-breadcrumb-item>
                <el-breadcrumb-item>答题详情</el-breadcrumb-item>
                <el-breadcrumb-item>查看详情</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" @click="toBack" class="go-back">返回</el-button>
        </div>
        <el-scrollbar class="table">
            <!--商品文字撰写-->
            <el-table :data="goodsTextList" v-if="goodsTextList.length > 0" class="customTable goods-text-table" style="width: 100%; flex: 1; margin-top: 20px" height="1%">
                <el-table-column prop="module" label="考试内容" width="200px"></el-table-column>
                <el-table-column label="提交答案（点击商品查看详情）" align="left" width="380px">
                    <template slot-scope="scope">
                        <router-link class="answer" :to="{path: '/teacher/goods/detail', query: { g_id: goods_id}}" target="_blank">
                            <img :src="scope.row.goods_images" alt="">
                            <span class="text">{{scope.row.goods_title}}</span>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column prop="search_num" label="搜索人数" align="center"></el-table-column>
                <el-table-column prop="click_rate" label="点击率" align="center"></el-table-column>
                <el-table-column prop="student_click_num" label="学生点击量" align="center"></el-table-column>
                <el-table-column prop="full_score_hits" label="满分点击量" align="center"></el-table-column>
                <el-table-column prop="score" :label="`得分（${total_score}分）`" align="center" width="150px"></el-table-column>
            </el-table>
            <!--商品拍摄与处理-->
            <el-table :data="goodsShootList" v-if="goodsShootList.length > 0" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="109px">
                <el-table-column prop="module" label="考试内容"></el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="viewGoodsImg" class="view-detail">查看详情</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--商品视频拍摄与处理-->
            <el-table :data="goodsVideoShootList" v-if="goodsVideoShootList.length > 0" class="customTable" style="width: 100%; flex: 1; margin-top: 20px" height="109px">
                <el-table-column prop="module" label="考试内容"></el-table-column>
                <el-table-column label="学生提交答案" align="center">
                    <template slot-scope="scope">
                        <div class="link-box">
                            <el-link type="success" :underline="false" @click="downloadFile" class="view-detail">下载文件</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>
        <el-dialog title="商品主图" :visible.sync="goodsImgDialog" width="764px" @close="handleCloseGoodsImgDialog" custom-class="green-dialog goods-img-dialog">
            <div class="upload-file-content">
                <div class="big-img">
                    <img :src="bigImg" alt="">
                </div>
                <div class="small-img">
                    <img :src="item" alt=""
                         v-for="(item, index) in goodsImgsList"
                         @click="viewBigImg(item, index)"
                         :class="{selected: selectIndex === index}">
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {teacheropTrainData} from '@/utils/apis'

    export default {
        name: "LookStudentDetail",
        data(){
            return {
                //商品文字信息撰写
                goodsTextList: [],
                //商品id
                goods_id: '',
                //得分
                total_score: '',
                //商品拍摄与处理
                goodsShootList: [],
                //商品视频拍摄与处理
                goodsVideoShootList: [],
                //下载路径
                download_file: '',
                //商品主图弹窗
                goodsImgDialog: false,
                //商品主图列表
                goodsImgsList: [],
                selectIndex: 0,
                //大图
                bigImg: '',
            }
        },
        mounted() {
            this.getTrainDetail();
        },
        methods:{
            //获取学生提交训练详情
            getTrainDetail() {
                let param = {
                    train_id: this.$route.query.train_id
                }
                teacheropTrainData(param).then((res) => {
                    let obj = {}
                    if (res.data) {
                        if (res.data.module === '商品文字信息撰写') {
                            obj = {
                                module: res.data.module,
                                click_rate: res.data.click_rate,
                                goods_images: res.data.goods_images,
                                goods_title: res.data.goods_title,
                                score: res.data.score,
                                search_num: res.data.search_num,
                                student_click_num: res.data.student_click_num,
                                full_score_hits: res.data.full_score_hits
                            }
                            this.goodsTextList.push(obj);
                            this.goods_id = res.data.id;
                            this.total_score = res.data.total_score;
                        }
                        if (res.data.module === '商品拍摄与处理') {
                            obj = {
                                module: res.data.module,
                                score: res.data.score,
                            }
                            this.goodsShootList.push(obj);
                            this.goodsImgsList = res.data.file_path;
                        }
                        if (res.data.module === '商品视频拍摄与处理') {
                            obj = {
                                module: res.data.module,
                                score: res.data.score,
                            }
                            this.goodsVideoShootList.push(obj);
                            this.download_file = res.data.download_path;
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                })
            },
            //查看商品主图
            viewGoodsImg() {
                this.goodsImgDialog = true;
                this.bigImg = this.goodsImgsList[0];
            },
            //查看大图
            viewBigImg(item, index) {
                this.selectIndex = index;
                this.bigImg = item;
            },
            //关闭商品主图弹窗
            handleCloseGoodsImgDialog() {
                this.goodsImgDialog = false;
                this.selectIndex = 0;
            },
            //下载文件
            downloadFile() {
                window.location.href = this.download_file;
            },
            toBack(){
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .answer-detail{
        padding: 0 20px;
        box-sizing: border-box;
        height: 100%;
        display: flex;
        flex-direction: column;
        .answer-detail-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px solid #F1F5FF;
            .go-back {
                margin-bottom: 12px;
            }
        }
        .table {
            height: 100%;
            padding-bottom: 20px;
            ::v-deep > .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }
        .goods-text-table {
            .answer {
                display: flex;
                align-items: center;
                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 15px;
                    cursor: pointer;
                }
                .text {
                    flex: 1;
                    width: 1%;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
            }
        }
        .link-box {
            .view-detail {
                ::v-deep .el-link--inner {
                    color: #1AB163;
                }
            }
        }
        .goods-img-dialog {
            .upload-file-content {
                display: flex;
                justify-content: space-between;
                width: 100%;
                height: 445px;
                .big-img {
                    width: 444px;
                    height: 444px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .small-img {
                    flex: 1;
                    width: 1%;
                    margin-left: 94px;
                    img {
                        width: 80px;
                        height: 80px;
                        margin-bottom: 15px;
                        border: 2px solid transparent;
                        box-sizing: border-box;
                        &:nth-child(2n-1) {
                            margin-right: 18px;
                        }
                        &:hover {
                            cursor: pointer;
                            border: 2px solid #2DC079;
                        }
                    }
                    .current-img {
                        border: 2px solid #2DC079;
                    }
                    .selected {
                        border: 2px solid #2DC079;
                    }
                }
            }
        }
        .goods-score-dialog {
            .upload-file-content {
                display: flex;
                flex-direction: column;
                height: 383px;
            }
        }
    }
</style>